import React from "react";
import { HashRouter, Route, Switch, Redirect } from "react-router-dom";
import { withRouter } from "react-router";
// components
import Layout from "./Layout";

// pages
import Error from "../pages/error";
import Login from "../pages/login";
import ForgotPassword from "../pages/ForgotPassword"

// context
//import { useUserState } from "../context/UserContext";

export default function App() {
  // global
  //var { isAuthenticated } = useUserState();

  return (
      <HashRouter>
        <Switch>
          <Route
            exact
            path="/"
          render={() => <Redirect to="/app/landlordDashboard" />}
          />
          <Route
            exact
            path="/app"
          render={() => <Redirect to="/app/landlordDashboard" />}
          />
          <PrivateRoute path="/app" component={withRouter(Layout)} />
          <PublicRoute path="/login" component={withRouter(Login)} />
          <PublicRoute path="/forgotpassword" component={withRouter(ForgotPassword)} />
          <Route component={Error} />
        </Switch>
      </HashRouter>
  );

  // #######################################################################

  function PrivateRoute({ component, ...rest }) {
    return (
      <Route
        {...rest}
        render={(props) =>
          localStorage.getItem("user") ? (
            React.createElement(component, props)
          ) : (
            <Redirect
              to={{
                pathname: "/login",
                state: {
                  from: props.location,
                },
              }}
            />
          )
        }
      />
    );
  }

  function PublicRoute({ component, ...rest }) {
    return (
      <Route
        {...rest}
        render={(props) =>
          false ? (
            <Redirect
              to={{
                pathname: "/",
              }}
            />
          ) : (
            React.createElement(component, props)
          )
        }
      />
    );
  }
}
